var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnboardingEmptyStateIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.4712 55.6197C50.058 55.23 66.6232 55.1344 83.1694 55.3312C84.3111 55.1115 85.556 55.4516 85.9601 56.0954C86.0441 56.2425 86.0848 56.3972 86.0794 56.5519V64.3748C86.2313 64.7913 85.9926 65.2211 85.4475 65.5134C84.9078 65.7962 84.1566 65.9108 83.4379 65.8191C67.8545 66.1553 52.2521 65.9738 36.7066 65.2765C35.4699 65.309 34.255 65.0721 33.3193 64.6136C32.8827 64.2793 32.5925 63.8896 32.4786 63.477V63.1713C31.9524 61.4405 31.7138 59.6849 31.7599 57.9274V56.8748L33.4712 55.6197Z",
    fill: "#F4F4F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.4711 76.0127C50.058 75.623 66.6232 75.5275 83.1693 75.7243C84.3111 75.5046 85.5559 75.8446 85.96 76.4884C86.0441 76.6355 86.0848 76.7903 86.0794 76.945V84.7679C86.2312 85.1844 85.9926 85.6142 85.4475 85.9065C84.9078 86.1892 84.1565 86.3038 83.4378 86.2121C67.8544 86.5484 52.252 86.3669 36.7066 85.6696C35.4699 85.7021 34.2549 85.4652 33.3193 85.0067C32.8826 84.6724 32.5924 84.2827 32.4785 83.87V83.5644C31.9524 81.8336 31.7137 80.078 31.7598 78.3205V77.2678L33.4711 76.0127Z",
    fill: "#F4F4F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.9406 65.9438L87.36 52.1093C87.36 52.1093 28.9818 51.0734 30.5496 52.1093C32.1174 53.1452 30.5496 66.8795 30.5496 66.8795L86.9406 65.9438Z",
    stroke: "#70758F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.3487 31.6783C71.9248 31.2478 76.4949 31.1423 81.0598 31.3597C81.3748 31.117 81.7182 31.4926 81.8297 32.2037C81.8529 32.3662 81.8641 32.5371 81.8626 32.708V41.3488C81.9045 41.8088 81.8387 42.2836 81.6883 42.6064C81.5394 42.9187 81.3321 43.0453 81.1339 42.944C76.8346 43.3154 72.5301 43.115 68.2413 42.3448C67.9001 42.3806 67.5649 42.119 67.3068 41.6126C67.1863 41.2433 67.1063 40.8128 67.0749 40.3571V40.0195C66.9297 38.1077 66.8639 36.1685 66.8766 34.2273V33.0646L67.3487 31.6783Z",
    fill: "#F4F4F5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.9406 90.0346L87.36 76.2002C87.36 76.2002 28.9817 75.1642 30.5495 76.2002C32.1174 77.2361 30.5495 90.9703 30.5495 90.9703L86.9406 90.0346Z",
    stroke: "#70758F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4957 23.661C25.4957 23.661 24.3443 89.3015 25.5511 101.57C26.7579 113.838 26.0454 111.247 39.6767 111.922C53.3081 112.596 88.3415 112.596 90.8521 111.078C93.3626 109.56 93.9608 100.285 93.8407 92.5294C93.7206 84.7739 95.8268 44.7608 94.6316 35.9922C89.2915 31.2299 80.7377 24.3317 75.6833 19.1758C59.1822 19.85 25.5519 19.793 25.5519 19.793C25.5519 19.793 25.5372 19.5878 25.4957 23.661Z",
    stroke: "#70758F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8553 11.3447C47.8708 14.251 46.9494 21.5514 46.1117 24.8384C43.2847 30.5472 37.9445 25.3574 40.1434 25.3574C41.9024 25.3574 42.1328 23.2814 42.0281 22.2435V14.4587C38.1368 10.3068 36.2184 13.9397 35.7456 16.2751C35.5362 20.8595 35.1174 31.3776 35.1174 36.7751C35.1174 43.5219 40.7716 44.5599 40.7716 39.889C40.7716 35.2181 44.8553 33.1422 46.7399 35.4776C48.6246 37.8131 47.3682 44.3004 40.1434 45.8574C34.3635 47.1029 31.8715 44.1274 31.3479 42.4839C31.1385 35.7371 30.8453 20.4789 31.3479 13.4207C35.7457 4.0789 41.0858 7.7118 44.8553 11.3447Z",
    fill: "#F4F4F5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2626 23.6346C45.9668 27.8689 42.195 27.5703 40.3461 26.8917C39.8119 26.2471 39.1628 24.9374 40.8391 24.856C42.5155 24.7745 42.688 23.4649 42.5648 22.8203V16.2042C42.7702 14.9828 42.3922 12.5399 39.2367 12.5399C36.0812 12.5399 35.2102 14.9828 35.1691 16.2042V39.7796C36.525 44.6653 42.195 43.5457 42.0717 38.8636C41.9731 35.1178 44.4959 35.7421 45.7696 36.5225C46.6324 39.3386 46.7556 45.1743 40.3461 45.9886C33.9365 46.8028 31.6767 43.5457 31.348 41.8153V13.456C36.0599 4.95753 43.5988 8.28953 46.2626 13.1507C46.3859 14.881 46.5584 19.4003 46.2626 23.6346Z",
    stroke: "#70758F",
    strokeWidth: 1.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3124 19.3037H41.0857L37.5088 20.7345L36.4357 23.5959L40.728 31.465L50.3855 28.2459L49.3124 19.3037Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9396 19.6616H49.3125",
    stroke: "#70758F",
    strokeWidth: 1.5
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2191 29.0228V19.3652L94.2582 35.6451C90.6712 36.013 82.7244 36.528 79.634 35.6451C76.5436 34.7621 75.4031 30.8623 75.2191 29.0228Z",
    fill: "#F4F4F5",
    stroke: "#70758F",
    strokeWidth: 1.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3816 106.283C34.3816 106.283 37.8247 99.5894 43.3701 100.26C47.429 100.75 49.569 104.818 49.569 104.818L57.0078 102.539",
    stroke: "#70758F",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardingEmptyStateIcon);
export default __webpack_public_path__ + "static/media/onboarding-empty-state-icon.f6d050461c9c5ca494c7418d82401f3e.svg";
export { ForwardRef as ReactComponent };